module.exports = __webpack_public_path__ + "static/whanau-1c94d9996c079248bf487b74250c5caa.png";